(function () {
  function init(container) {
    var section = container || document.querySelector('.oddit-section-pdp-how-to');
    if (!section) return;
    var track = section.querySelector('.oddit-section-pdp-how-to__cards');
    var cards = section.querySelectorAll('.oddit-section-pdp-how-to__card');
    var dots = section.querySelectorAll('.oddit-section-pdp-how-to__dot');
    if (!track || !cards.length || !dots.length) return;

    var mql = window.matchMedia('(min-width: 990px)');
    var io = null;

    function setActive(index) {
      dots.forEach(function (d, i) {
        d.classList.toggle('oddit-section-pdp-how-to__dot--active', i === index);
      });
    }

    function enable() {
      if (io) return;
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var index = Array.prototype.indexOf.call(cards, entry.target);
          if (index >= 0) setActive(index);
        });
      }, { root: track, threshold: 0.6 });
      cards.forEach(function (c) { io.observe(c); });
    }

    function disable() {
      if (!io) return;
      io.disconnect();
      io = null;
    }

    function sync() {
      if (mql.matches) disable();
      else enable();
    }

    function teardown() {
      disable();
      mql.removeEventListener('change', sync);
    }

    sync();
    mql.addEventListener('change', sync);

    section.__odditPdpHowToTeardown = teardown;
  }

  init();

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector('.oddit-section-pdp-how-to')) {
      init(e.target.querySelector('.oddit-section-pdp-how-to'));
    }
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var section = e.target.querySelector('.oddit-section-pdp-how-to');
    if (section && section.__odditPdpHowToTeardown) {
      section.__odditPdpHowToTeardown();
    }
  });
})();
